module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.forgotPasswordDisp || _vm.forgotPasswordVerifyDisp),
      expression: "forgotPasswordDisp || forgotPasswordVerifyDisp"
    }],
    staticClass: "box-forgot-password clearfix"
  }, [_c('forgot-password-request', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.forgotPasswordDisp),
      expression: "forgotPasswordDisp"
    }],
    attrs: {
      "forgotPasswordDisp": _vm.forgotPasswordDisp,
      "pcDisp": _vm.pcDisp,
      "loadingDisp": _vm.loadingDisp,
      "goLogin": _vm.goLogin,
      "postForgotPassword": _vm.postForgotPassword,
      "response": _vm.response,
      "setForgotPasswordResponse": _vm.setForgotPasswordResponse,
      "inputUsername": _vm.inputUsername,
      "labels": _vm.labels
    }
  }), _vm._v(" "), _c('forgot-password-verify', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.forgotPasswordVerifyDisp),
      expression: "forgotPasswordVerifyDisp"
    }],
    attrs: {
      "pcDisp": _vm.pcDisp,
      "goLogin": _vm.goLogin,
      "postForgotPasswordVerify": _vm.postForgotPasswordVerify,
      "response": _vm.response,
      "setResponse": _vm.setForgotPasswordResponse,
      "inputUsername": _vm.inputUsername,
      "labels": _vm.labels
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1cfd25fb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/forgotPassword.vue
// module id = 3610
// module chunks = 1